import * as defaultDynamicModels from './lib/dynamic'
import * as modelCollection from './lib/model-collection'
import * as defaultObservationModels from './lib/observation'

function camelToDash(str: string) {
  if (str === str.toLowerCase()) {
    return str
  }
  return str.replaceAll(/[A-Z]/g, m => `-${m.toLowerCase()}`)
}

Object.keys(defaultDynamicModels).forEach((k: string) => {
  modelCollection.registerDynamic(camelToDash(k), defaultDynamicModels[k])
})

Object.keys(defaultObservationModels).forEach((k: string) => {
  modelCollection.registerObservation(camelToDash(k), defaultObservationModels[k])
})

export * from './lib/dynamic'
export { default as KalmanFilter } from './lib/kalman-filter'
export * from './lib/model-collection'

export * from './lib/observation'
export { default as State } from './lib/state'
export { default as checkCovariance } from './lib/utils/check-covariance'
export { default as correlationToCovariance } from './lib/utils/correlation-to-covariance'
export { default as covarianceToCorrelation } from './lib/utils/covariance-to-correlation'
export { default as getCovariance } from './lib/utils/get-covariance'
export { default as projectObservation } from './lib/utils/project-observation'
